module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/20dcc73bce3cc53ca31a41c5bf17c201.png";